const textHeight = 100;
const titleIndent = 20;
const keywordWidth = 20;
const maxBarLength = 50;
const padding = 20;
const metadataColumnWidth = 200;

export {
  textHeight,
  titleIndent,
  keywordWidth,
  maxBarLength,
  padding,
  metadataColumnWidth
};
